import { render, staticRenderFns } from "./WidgetForm.vue?vue&type=template&id=18986176&scoped=true"
import script from "./WidgetForm.vue?vue&type=script&lang=js"
export * from "./WidgetForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetForm.vue?vue&type=style&index=0&id=18986176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18986176",
  null
  
)

export default component.exports